import { useGetProfilesForCaseQuery } from "~/graphql/supergraphHooks";
import { useIOReusableProfiles } from "~/pages/Compliance/flags";
import { getExistingOwnershipTotal } from "./ownershipCap";

export const useExistingOwnershipTotal = (
  caseId: number,
  parentProfileId: number | undefined,
): number => {
  const ioReusableProfilesEnabled = useIOReusableProfiles();
  const { data } = useGetProfilesForCaseQuery({
    variables: { caseId, ioReusableProfilesEnabled },
    skip: parentProfileId == null,
    fetchPolicy: "cache-and-network",
  });

  if (parentProfileId == null) return 0;
  return getExistingOwnershipTotal(data?.complianceCase ?? null, parentProfileId);
};
